import React, { useState,useRef } from 'react';
import axios from 'axios';
import { Alert, Form, Button, Container, Row, Col } from 'react-bootstrap';
import Rgpd from './rgpd';
import ReCAPTCHA from 'react-google-recaptcha'


function InscriptionEquipe() {
  const [isError, setIsError] = useState(false);
  const [name, setName] = useState('');
  const [prenom, setPrenom] = useState('');
  const [date, setDate] = useState('');
  const [contact, setContact] = useState('');
  const [equipe, setEquipe] = useState('');
  const [categorie, setCategorie] = useState('');
  const [adresse, setAdresse] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rgpdChecked, setRgpdChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const recaptcha = useRef()

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const captchaValue = recaptcha.current.getValue()


    if (!rgpdChecked) {
      setError("Veuillez accepter les conditions d'inscription pour continuer.");
      setIsLoading(false);
      return;
    } else if (!name || !email || !password || !confirm || !equipe || !categorie || !adresse || !date || !prenom || !contact || !file || !file2) {
      setError("Veuillez remplir tous les champs du formulaire.");
      setIsLoading(false);
      return;
    } else if (!captchaValue) {
      setError("Veuillez vérifier le captcha");
      setIsLoading(false);
      return;
    }else if (password !== confirm) {
      setError("Les mots de passe ne correspondent pas");
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();
      formData.append('nom', name);
      formData.append('prenom', prenom);
      formData.append('mail', email);
      formData.append('mdp', password);
      formData.append('confirm_mdp', confirm);
      formData.append('equipe', equipe);
      formData.append('categorie', categorie);
      formData.append('adresse', adresse);
      formData.append('date', date);
      formData.append('contact', contact);
      formData.append('file', file);
      formData.append('file2', file2);
      formData.append('captcha', captchaValue);


      const response = await axios.post(`${apiUrl}/inscription/equipe`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setResponse(response.data);
      setError(null);
      setSubmitted(true);
    } catch (error) {
      setResponse(null);
      setSubmitted(false);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setIsError(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br/>
        <span className="loader"></span>
      </div>
    );
  }

  if (isError) {
    return (
      <div id="alert-message" className="alert5" >
        <strong>ERROR SERVEUR ! </strong> <span id="alert-text"></span>
      </div>
    );
  }

  return (
    <Container  style={{padding:"25px", boxShadow:"none"}}>
      {submitted && response ? (
        <Alert variant="success" className="mt-3">
          <strong>Félicitations {response.user.name} ! </strong>Votre inscription a été envoyée avec succès.
        </Alert>
      ) : (
        <Form onSubmit={handleSubmit}>
          <h1 className="text-center my-4">Inscription des équipes</h1>
          {error && (
            <Alert variant="danger">
              {error}
            </Alert>
          )}
          <Rgpd showModal={showModal} setShowModal={setShowModal} setRgpdChecked={setRgpdChecked} />
          <Row>
            <Col md={6}>
              <Form.Group controlId="nom">
                <Form.Label>Nom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nom"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="prenom">
                <Form.Label>Prénom</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Prénom"
                  value={prenom}
                  onChange={(e) => setPrenom(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group controlId="date">
            <Form.Label>Date de naissance</Form.Label>
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="telephone">
            <Form.Label>Numéro de téléphone</Form.Label>
            <Form.Control
              type="tel"
              placeholder="0490-508-401"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="equipe">
            <Form.Label>Nom de l'équipe</Form.Label>
            <Form.Control
              type="text"
              placeholder="FC Mons"
              value={equipe}
              onChange={(e) => setEquipe(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="categorie">
            <Form.Label>Catégorie d'âge</Form.Label>
            <Form.Select
              value={categorie}
              onChange={(e) => setCategorie(e.target.value)}
              required
            >
              <option>Sélectionner</option>
              <option value="U5">U5</option>
              <option value="U6">U6</option>
              <option value="U7">U7</option>
              <option value="U8">U8</option>
              <option value="U9">U9</option>
              <option value="U10">U10</option>
              <option value="U11">U11</option>
              <option value="U12">U12</option>
              <option value="U13">U13</option>
              <option value="U14">U14</option>
              <option value="U15">U15</option>
              <option value="U16">U16</option>
              <option value="U17">U17</option>
              <option value="U18">U18</option>
              <option value="U19">U19</option>
              <option value="U20">U20</option>
              <option value="U21">U21</option>
              <option value="Réserve">Réserve</option>
              <option value="Equipe première">Equipe première</option>
            </Form.Select>
          </Form.Group>
          <Form.Group controlId="adresse">
            <Form.Label>Adresse du club</Form.Label>
            <Form.Control
              type="text"
              placeholder="Rue albert 6, 5000 Namur"
              value={adresse}
              onChange={(e) => setAdresse(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="nom.prenom@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>Mot de passe</Form.Label>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <Form.Text className="text-muted">
              Avec au moins 12 caractères, 1 caractère spécial et 1 chiffre.
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="confirmPassword">
            <Form.Label>Confirmer votre mot de passe</Form.Label>
            <Form.Control
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="doc1">
            <Form.Label>Document Equipe en format PDF</Form.Label>
            <Form.Control
              type="file"
              accept=".pdf"
              onChange={(e) => setFile(e.target.files[0])}
              required
            />
          </Form.Group>
          <Form.Group controlId="doc2">
            <Form.Label>Ecusson en PNG</Form.Label>
            <Form.Control
              type="file"
              accept=".png"
              onChange={(e) => setFile2(e.target.files[0])}
              required
            />
          </Form.Group>
          <br/>
          <Form.Group controlId="rgpd">
          <Form.Check
              type="checkbox"
              label="En soumettant ce formulaire, j'accepte que mes données personnelles soient traitées conformément aux conditions d'inscription."
              checked={rgpdChecked}
              onChange={() => {
                if (!rgpdChecked) {
                  setShowModal(true);
                } else {
                  setRgpdChecked(false);
                }
              }}
            />
          </Form.Group>
          <br/>
            <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_KEY_CAPTCHA} />
            <br/>
          <div className="text-center">
            <Button variant="primary" type="submit" style={{backgroundColor:"#00E676", borderColor:'#00E676'}} disabled={!rgpdChecked}>
              Inscription
            </Button>
          </div>
        </Form>
      )}
    </Container>
  );
}

export default InscriptionEquipe;
